// src/components/AdminDashboard.js

import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import Header from "./Header";

function AdminDashboard() {
  // State for Payment Form
  const [paymentUserId, setPaymentUserId] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");

  // State for Session Form
  const [sessionUserId, setSessionUserId] = useState("");
  const [numVehicles, setNumVehicles] = useState(""); // Changed state to store number of vehicles
  const [cost, setCost] = useState("");

  // Handler for Adding Payment
  const handleAddPayment = async (e) => {
    e.preventDefault();
    if (!paymentUserId || !paymentAmount) {
      alert("Please fill in all payment fields.");
      return;
    }

    try {
      await addDoc(collection(db, "payments"), {
        userId: paymentUserId,
        amount: parseFloat(paymentAmount),
        date: new Date(),
      });
      alert("Payment added successfully!");
      setPaymentUserId("");
      setPaymentAmount("");
    } catch (error) {
      console.error("Error adding payment: ", error);
      alert("Failed to add payment.");
    }
  };

  // Handler for Logging Session
  const handleAddSession = async (e) => {
    e.preventDefault();
    if (!sessionUserId || !numVehicles || !cost) {
      alert("Please fill in all session fields.");
      return;
    }

    try {
      await addDoc(collection(db, "sessions"), {
        userId: sessionUserId,
        numVehicles: parseInt(numVehicles, 10), // Store number of vehicles
        cost: parseFloat(cost),
        sessionDate: new Date(),
      });
      alert("Session logged successfully!");
      setSessionUserId("");
      setNumVehicles("");
      setCost("");
    } catch (error) {
      console.error("Error logging session: ", error);
      alert("Failed to log session.");
    }
  };

  return (
    <div style={styles.container}>

      <Header></Header>

      <h2 className="mt-10">Admin Dashboard</h2>

      {/* Add Payment Form */}
      <div style={styles.formContainer}>
        <h3>Add Payment</h3>
        <form onSubmit={handleAddPayment} style={styles.form}>
          <input
            type="text"
            placeholder="User ID"
            value={paymentUserId}
            onChange={(e) => setPaymentUserId(e.target.value)}
            style={styles.input}
          />
          <input
            type="number"
            placeholder="Amount"
            value={paymentAmount}
            onChange={(e) => setPaymentAmount(e.target.value)}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Add Payment</button>
        </form>
      </div>

      {/* Log Charging Session Form */}
      <div style={styles.formContainer}>
        <h3>Log Charging Session</h3>
        <form onSubmit={handleAddSession} style={styles.form}>
          <input
            type="text"
            placeholder="User ID"
            value={sessionUserId}
            onChange={(e) => setSessionUserId(e.target.value)}
            style={styles.input}
          />
          <input
            type="number"
            placeholder="No of Vehicles" // Updated label
            value={numVehicles}
            onChange={(e) => setNumVehicles(e.target.value)}
            style={styles.input}
          />
          <input
            type="number"
            placeholder="Cost"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Log Session</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: "600px",
    margin: "0 auto",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },
  formContainer: {
    marginBottom: "40px",
    padding: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: {
    padding: "10px",
    marginBottom: "10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  button: {
    padding: "10px",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#28a745",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
  },
};

export default AdminDashboard;
